import * as userActions from '../../reducers/user';

const setAuthorizedUsers = (data) => (dispatch) => {
  dispatch(userActions.setAuthorizedUsers(data));
};

export default setAuthorizedUsers;
